import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.element.isRequired,
  tip: PropTypes.string.isRequired,
};

const Bubble = styled.span`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.border.thick};
  padding: ${props => props.theme.space.half};
  position: absolute;
  bottom: -10px;
  left: 50%;
  text-align: center;
  visibility: hidden;
  z-index: 1;
  transform: translate(-50%, 100%);

  &:after {
    border-color: transparent transparent ${props => props.theme.colors.primary} transparent;
    border-style: solid;
    border-width: ${props => props.theme.border.thick};
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-top: -5px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  &:hover ${Bubble} {
    visibility: visible;
  }
`;

const ToolTip = ({
  children,
  tip,
}) => (
  <Wrapper>
    {children}
    <Bubble>{tip}</Bubble>
  </Wrapper>
);

ToolTip.propTypes = propTypes;

export default ToolTip;
